/**
 * Per-org feature flags. Mirrors the backend's DEFAULT_FEATURES in
 * backend/src/helpers/orgFeatures.ts. Backend merges stored JSONB against
 * those defaults, so the client never sees a missing key.
 *
 * Default `false` for any flag we add here is the safe choice — the flag is
 * "off until proven on" so any new flag won't accidentally enable UI for
 * orgs that haven't opted in yet.
 */
export interface FeatureFlags {
  speed_limits: boolean;
}

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  speed_limits: false,
};
